import { Stack, Text, Title } from '@mantine/core'
import React from 'react'
import { useTranslation } from 'react-i18next'

const openLoginUrl = process.env.WEB3AUTH_UI_URL || 'https://app.openlogin.com'

interface AccountManagementProps {
  privKey: () => void
  isMobile: boolean
  isMetamask: boolean
}

const AccountManagement: React.FC<AccountManagementProps> = ({ privKey, isMobile, isMetamask }) => {
  const { t } = useTranslation()
  return (
    <Stack>
      <Title order={isMobile ? 4 : 3}>
        {t('components.settings.accountManagement', 'Account Management')}
      </Title>
      {!isMetamask && (
        <Text style={{ fontSize: '18px' }}>
          <a href={openLoginUrl} target="_blank" rel="noreferrer">
            {t('components.settings.manageAccount', 'Manage your account')}
          </a>
        </Text>
      )}
      <Text style={{ fontSize: '18px' }}>
        <a style={{ cursor: 'pointer' }} onClick={privKey}>
          {t('components.settings.exportPrivKey', 'Export private key')}
        </a>
      </Text>
    </Stack>
  )
}

export default AccountManagement
